<template>
  <Modal v-model="visible" title="选择产品" width="1200" class="my-modal" :mask-closable="false" :footer-hide="true">
    <div class="search-box btn3">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input class="value" v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="name">
          <span class="name" @click="preview(row)">{{ row.name }}</span>
        </template>
        <template slot-scope="{ row }" slot="articleType">
          <span>{{ articleType[row.articleType] }}</span>
        </template>
        <template slot-scope="{ row }" slot="isShare">
          <span v-if="row.isShare == 1">是</span>
          <span v-else>否</span>
        </template>

        <template slot-scope="{ row }" slot="isUse">
          <span v-if="row.isUse == 1">上架</span>
          <span v-else>下架</span>
        </template>

        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellType">
            <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <div class="action">
            <a @click="confirmSelect(row)">确认选择</a>
          </div>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
  </Modal>
</template>

<script>
import { filterTime } from '@/api/filter';
import { pageTool, common } from '@/api/mixins';
export default {
  props: [],
  mixins: [pageTool, common],
  components: {},
  data() {
    return {
      articleTypeList: [], //课程类型列表
      articleType: {}, //课程类型
      visible: false,
      tableData: [],
      columns: [
        //表格字段
        {
          title: '课程名称',
          key: 'name',
          align: 'left',
          minWidth: 240,
          // tree: true,
          slot: 'name'
        },
        {
          title: '课程分类',
          key: 'articleColumnName',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            let text = params.row.articleColumnName;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: '课程类型',
          slot: 'articleType',
          align: 'center',
          minWidth: 100
        },
        {
          title: '来源',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sourceFrom = params.row.sourceFrom;
            switch (sourceFrom) {
              case 0:
                return <span>素材库</span>;
              default:
                return <span>自建</span>;
            }
          }
        },
        {
          title: '是否可分享',
          slot: 'isShare',
          align: 'center',
          minWidth: 120
        },
        {
          title: '是否上架',
          slot: 'isUse',
          align: 'center',
          minWidth: 120
        },
        {
          title: '最后更新人',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const userName = params.row.userName;
            return <span>{userName ? userName : '-'}</span>;
          }
        },
        {
          title: '上架时间',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            const useTime = params.row.useTime;
            return <span>{useTime ? filterTime(useTime, 'YYYY-MM-DD HH:mm') : '-'}</span>;
          }
        },
        {
          title: '操作',
          minWidth: 80,
          align: 'center',
          slot: 'action',
          fixed:'right'
        }
      ],
      total: 0,
      searchParams: {
        isUse: '1',
        isShare: ''
      },

      selectArr: [],
      isAll: false //全选
    };
  },
  methods: {
    listCallback(res) {
      console.log(res);
      this.tableData = res.data.map(item => {
        // 一级
        if (item.children) {
          delete item.children;
        }
        return item;
      });
    },
    open() {
      this.articleType = JSON.parse(localStorage.dic)['TRAIN_ARTICLE_TYPE'];
      if (this.articleType) {
        for (let key in this.articleType) {
          this.articleTypeList.push({
            id: key,
            name: this.articleType[key]
          });
        }
      }
      this.initListAjax('/buz/course/read/list');
      this.visible = true;
    },

    // 选中产品
    confirmSelect(item) {
      this.$emit('confirm-select', item);
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
      padding-bottom: 30px;
    }
  }
  .form {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .input-item {
      display: flex;
      align-items: center;
      padding-right: 50px;
    }
    .label {
      min-width: 70px;
    }
    .value {
      width: 300px;
      min-width: 200px;
    }
    /deep/ .add-btn {
      background: #f59045 !important;
      border: none;
    }
  }
  .setTable {
    margin-top: 20px;
    .action {
      font-size: 12px;
    }
  }
  .pageBox {
    margin-top: 20px;
  }
  /deep/ .setTable .ivu-table th .ivu-table-cell {
    font-size: 12px;
    font-weight: bold;
    color: #272933;
  }
  /deep/ .ivu-table-tip {
    font-size: 12px;
  }
}
</style>